import { useQuery } from "@tanstack/react-query";
import type { Brand } from "@contracts/api";
import { fetchBrandPages, inboxKeys, sumToday, wazzupToken } from "./inbox-api";

/**
 * เพจของแบรนด์พร้อมจำนวนข้อความวันนี้
 * ยังไม่ login = ไม่ยิงเลย (ของเดิมคืน null เงียบ ๆ) — UI แสดงว่า "ยังไม่รู้ตัวเลข"
 */
export function useBrandPages(brand: Brand | null) {
  const hasToken = !!wazzupToken();
  return useQuery({
    queryKey: inboxKeys.pages(brand?.pageIds ?? []),
    queryFn: () => fetchBrandPages(brand!),
    enabled: !!brand && hasToken,
  });
}

/** ตัวเลขต่อท้ายเมนู Messages = ห้องที่มีข้อความวันนี้ (ทุกช่องทางรวมกัน) */
export function useBrandTodayCount(brand: Brand | null): number {
  const { data } = useBrandPages(brand);
  return data ? sumToday(data) : 0;
}
